import { render, staticRenderFns } from "./halopsa-send-company-widget.vue?vue&type=template&id=087560fc&scoped=true&"
import script from "./halopsa-send-company-widget.vue?vue&type=script&lang=js&"
export * from "./halopsa-send-company-widget.vue?vue&type=script&lang=js&"
import style0 from "./halopsa-send-company-widget.vue?vue&type=style&index=0&lang=css&"
import style1 from "./halopsa-send-company-widget.vue?vue&type=style&index=1&id=087560fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087560fc",
  null
  
)

export default component.exports